(() => {
  const product = document.querySelector('.main-product');
  if (!product || !('IntersectionObserver' in window)) return;

  const mobile = window.matchMedia('(max-width: 767px)');
  const selectors = '[id^="variant-update-"], .product-form__quantity, form[data-type="add-to-cart-form"], .sticky_add_to_cart';
  let targets = new Set();
  let pending = false;

  const update = () => {
    const height = window.innerHeight;
    const width = window.innerWidth;
    const visible = mobile.matches && [...targets].some(element => {
      if (element.closest('.sticky_add_to_cart')) return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > -12 && rect.top < height + 12 && rect.right > 0 && rect.left < width;
    });
    document.body.classList.toggle('dv-shopping-focus', visible);
    let clearance = 0;
    if (mobile.matches) {
      product.querySelectorAll('.sticky_add_to_cart').forEach(element => {
        const rect = element.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0 && rect.top < height && rect.bottom > 0) clearance = Math.max(clearance, height - rect.top + 16);
      });
    }
    document.body.style.setProperty('--dv-mobile-float-clearance', `${clearance}px`);
  };

  const intersection = new IntersectionObserver(update, {rootMargin:'12px 0px'});
  const refresh = () => {
    pending = false;
    const current = new Set(product.querySelectorAll(selectors));
    targets.forEach(element => {
      if (!current.has(element)) intersection.unobserve(element);
    });
    current.forEach(element => {
      if (!targets.has(element)) intersection.observe(element);
    });
    targets = current;
    update();
  };
  const mutations = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(refresh);
  });

  mutations.observe(product, {childList:true, subtree:true});
  mobile.addEventListener('change', update);
  window.addEventListener('resize', update, {passive:true});
  window.addEventListener('pageshow', refresh);
  refresh();
})();